<template>
  <div :class="{ 'has-logo': showLogo }">
    <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
    <!-- <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routers"
          :key="route.name"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar> -->
    <div class="menu">
      <el-menu
        :router="true"
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        background-color="#ffffff"
        @select="select"
        >
          <el-menu-item v-for="(item,index) in list" :key="index" :index="item.path">
            <div :class="active==item.path ? 'active':''" class="hover"></div>
            <div class="menu-boxss">
              <img :src="active==item.path ? item.active:item.img" alt="">
              <span :class="active==item.path ? 'titleColor':''">{{item.title}}</span>
            </div>
          </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import Cookies from 'js-cookie'
// import Utils from '@/utils/utils';
export default {
  components: {
    SidebarItem,
    Logo
  },
  data(){
    return{
      active:'/',
      list:[
        {
          path:'/',
          img:require('../../../../assets/image/school.png'),
          active:require('../../../../assets/image/activeSchool.png'),
          title:'课程'
        },
        {
          path:'/forum/list',
          img:require('../../../../assets/image/forum.png'),
          active:require('../../../../assets/image/activeForum.png'),
          title:'论坛'
        },
        {
          path:'/match/match',
          img:require('../../../../assets/image/match.png'),
          active:require('../../../../assets/image/activeMatch.png'),
          title:'赛事'
        },
        // 我的钱包
        // {
        //   path:'/mine/my_wallet/consumption',
        //   img:require('../../../../assets/image/mine.png'),
        //   active:require('../../../../assets/image/activeMine.png')
        // }
        {
          path:'/mine/my_community/my_attention',
          img:require('../../../../assets/image/mine.png'),
          active:require('../../../../assets/image/activeMine.png'),
          title:'我的'
        }
      ]
    }
  },
  watch:{
    // 如果未登录或者未认证则跳转到论坛，并添加选中事件
    $route(to,from){
      if(to.path=='/forum/list'){
        if(!Cookies.get('Admin-Token') || !JSON.parse(localStorage.getItem('userInfo')).student_id){
          this.active=to.path
        }
      }
      // 监听路由变化改变侧边栏选中状态
      else if(to.path.indexOf("school")!=-1){
        this.active='/'
      }else if(to.path.indexOf("forum")!=-1){
        this.active='/forum/list'
      }else if(to.path.indexOf("match")!=-1){
        this.active='/match/match'
      }else if(to.path.indexOf("mine")!=-1){
        this.active='/mine/my_community/my_attention'
      }
    }
  },
  mounted(){
    this.active=this.$route.path
    //  if(window.location.pathname.indexOf("school")!=-1){
    //     this.active='/'
    //   }else if(window.location.pathname.indexOf("forum")!=-1){
    //     this.active='/forum/list'
    //   }else if(window.location.pathname.indexOf("match")!=-1){
    //     this.active='/match/match'
    //   }else if(window.location.pathname.indexOf("mine")!=-1){
    //     this.active='/mine/my_community/my_attention'
    //   }
  },
  methods:{
    select(e){
      this.active=e
    }
  },
  computed: {
    ...mapGetters(["sidebar", "routers"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>
<style lang="scss">
.el-submenu__title:hover{
  background-color: #EAF1FE !important;
}
.el-menu-item:hover{
  background-color: #EAF1FE !important;
}
  .menu{
    width: 90px;
    height: 100vh;
    .el-menu-item{
      height: 90px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
      .active{
        width: 5px;
        height: 40px;
        background: #3D7EFF;
        border-radius: 0px 100px 100px 0px;
        position: absolute;
        left: 0;
      }
      .menu-boxss{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img{
          width: 30px;
          height: 30px;
          margin-bottom: 18px;
        }
        span{
          position: absolute;
          top: 32px;
          color: #CCCCCC;
        }
        .titleColor{
          color: #3D7EFF;
        }
      }
    }
  }
</style>
